import { Component, Input, OnInit } from '@angular/core';
import { PruHttpService } from '../../../services/pru-http.service';
import { AnalyticService } from '../../../services/analytic.service';
import { GenericService } from '../../../services/generic.service';

@Component({
  selector: "ret-account-messaging",
  templateUrl: "./account-messaging.component.html",
  styleUrls: ["./account-messaging.component.scss"]
})
export class AccountMessagingComponent implements OnInit {
  @Input() contractId: string;
  @Input() additionalValues: any;
  accountMessages: any;
  amUrls: any;
  queryparam: string;
  static instances: Array<AccountMessagingComponent> = [];
  constructor(private _pruHttp: PruHttpService, private _genericService: GenericService, private _analyticService: AnalyticService,) {
    AccountMessagingComponent.instances.push(this);
  }

  ngOnInit() {
    this.additionalValues = this.additionalValues || {};
    this.queryparam = "pptycd=" + this.additionalValues["pptTyCd"] + "&logoname=" + this.additionalValues["globalLogoFileNm"] + "&appKey=WEB&userType=P&upid=" + this.contractId;
    this.amUrls = {
      enrollUrl: "/myprurouting?alias=Enroll&" + this.queryparam,
      investmentAllocation: "/myprurouting?alias=InvestmentAllocation&" + this.queryparam,
      rollover: "/myprurouting?alias=Rollover&" + this.queryparam,
      contribution: "/myprurouting?alias=Contributions&" + this.queryparam
    };
    let customHeaders = {
      "X-PruBU-RET-ApplicationKey": "WEB",
      "X-PruBU-RET-UserType": this._genericService.usr_csr ? 'I' : 'P'
    };
    this._pruHttp
      .post("/retirement/v1/user/accountMessaging", "ret-account-messaging", {
        plans: [
          {
            univlPlanId: this.contractId,
            pptTyCd: this.additionalValues["pptTyCd"]
          }
        ]
      }, customHeaders)
      .subscribe(
        (res: any) => {
          if (res.responseData && res.responseData.plans) {
            let msg = res.responseData.plans[0];
            msg["msgCd"] = msg["msgCd"] ? msg["msgCd"].trim() : '';
            msg['queryparam'] = this.queryparam;
            this.accountMessages = msg;
            window['containerName'] = msg["msgCd"];
            window['isMessagePresent'] = "Yes";
            if (msg["msgCd"] === "NOMSG" || (msg["msgCd"] === "SMALLCHG" && !this.hasSingleNudge())){
              window['isMessagePresent'] = "NO";
            }
            this._analyticService.notifyAnalytics("Plan Messaging Container Event");
          }
        },
        err => {
          this.accountMessages = null;
        }
      );
  }

  hasSingleNudge() {
    let counter = 0;
    AccountMessagingComponent.instances.forEach(element => {
      if (
        element.accountMessages &&
        element.accountMessages["msgCd"] === "SMALLCHG"
      ) {
        counter++;
      }
    });
    return counter === 1;
  }
  ngOnDestroy() {
    AccountMessagingComponent.instances = AccountMessagingComponent.instances.filter(
      element => element !== this
    );
  }
}
